// All customers related apis
import { API_URL } from './api';
import instance from './api';
import { encryptData } from '../helpers/encryptDecrypt';

// Get api for fetching all the deliveries for the active organization
export const fetchDeliveries = async (organizationId) => {
  const oId = encryptData(organizationId);
  return await instance.get(`${API_URL}/deliveries?organization_id=${oId}`);
};

// Post api for creating a new delivery for active organization
export const addDelivery = async (organizationId, delivery) => {
  return await instance.post(`${API_URL}/deliveries`, { ...delivery, organization_id: organizationId });
};

// Put api for updating existing delivery's details
export const updateDelivery = async (organizationId, delivery) => {
  const dId = encryptData(delivery.id);
  return await instance.put(`${API_URL}/deliveries/${dId}`, { ...delivery, organization_id: organizationId });
};

// Delete api for deleting existing delivery's details
export const deleteDelivery = async (id) => {
  const dId = encryptData(id);
  return await instance.delete(`${API_URL}/deliveries/${dId}`);
};
